/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extraction_Status_To_ReviewInputs */

const en_extraction_status_to_review = /** @type {(inputs: Extraction_Status_To_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To review`)
};

/**
* | output |
* | --- |
* | "To review" |
*
* @param {Extraction_Status_To_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const extraction_status_to_review = /** @type {((inputs?: Extraction_Status_To_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extraction_Status_To_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_extraction_status_to_review(inputs)
});